<template>
  <v-card id="customer-loyalty">
    <v-card-title class="text-h6">
      Бонусы клиента
    </v-card-title>

    <v-card-text class="pb-0">
      <span class="text--secondary">
        Данные приходят из CRM по номеру телефона — в нашей базе бонусов нет.
        Карта показана ровно так, как её увидит гость в приложении.
      </span>

      <v-row
        dense
        class="mt-4"
      >
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="phoneNumber"
            label="Номер телефона"
            placeholder="996700000000"
            dense
            outlined
            hide-details
            clearable
            @keyup.enter="search"
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
          class="d-flex align-center"
        >
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="!phoneNumber"
            @click="search"
          >
            <v-icon
              size="18"
              class="me-2"
            >
              {{ icons.mdiMagnify }}
            </v-icon>
            <span>Показать</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-alert
        v-if="error"
        type="error"
        dense
        text
        class="mt-4 mb-0"
      >
        {{ error }}
      </v-alert>

      <v-alert
        v-if="searched && !loading && !error && !card.found"
        type="warning"
        dense
        text
        class="mt-4 mb-0"
      >
        Держатель с таким номером в CRM не найден.
      </v-alert>
    </v-card-text>

    <v-card-text v-if="card.found">
      <v-row>
        <v-col
          cols="12"
          md="5"
        >
          <div class="loyalty-card">
            <div class="d-flex align-center justify-space-between">
              <span class="text--secondary text-sm">{{ fullName || 'Гость' }}</span>
              <span class="text--secondary text-sm">{{ card.cardNumber }}</span>
            </div>

            <div
              v-if="!card.programs.length"
              class="text--secondary mt-4"
            >
              У держателя нет ни одного счёта из настроенных программ.
            </div>

            <div
              v-for="(program, index) in card.programs"
              :key="program.name"
              :class="index ? 'mt-4 pt-4 loyalty-divider' : 'mt-4'"
            >
              <div class="text--secondary text-sm">
                Бонусы {{ program.name }}
              </div>
              <div class="d-flex align-baseline">
                <span class="text-h5 font-weight-medium">{{ money(program.bonus) }}</span>
                <span class="text--secondary text-sm ms-1">с</span>
              </div>
              <v-chip
                v-if="program.level"
                small
                class="mt-2"
              >
                {{ program.level }}
              </v-chip>
              <div class="d-flex justify-space-between mt-2 text-sm">
                <span class="text--secondary">Потрачено</span>
                <span>{{ money(program.spent) }} с</span>
              </div>
            </div>
          </div>
        </v-col>

        <v-col
          cols="12"
          md="7"
        >
          <div class="text--secondary mb-2">
            Все счета держателя {{ card.holderId }}
          </div>
          <v-data-table
            :headers="headers"
            :items="accounts"
            :items-per-page="15"
            hide-default-footer
            dense
            class="text-no-wrap"
          >
            <template #[`item.inUse`]="{item}">
              <v-icon
                v-if="item.inUse"
                size="18"
                color="success"
              >
                {{ icons.mdiCheck }}
              </v-icon>
              <span
                v-else
                class="text--disabled"
              >—</span>
            </template>

            <template #[`item.balance`]="{item}">
              {{ money(item.balance) }}
            </template>
          </v-data-table>
          <p class="text--secondary text-sm mt-2 mb-0">
            Галочкой отмечены счета, которые попали в карту по текущей настройке программ.
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiCheck, mdiMagnify } from '@mdi/js'

export default {
  name: 'CustomerLoyalty',
  data: () => ({
    icons: { mdiCheck, mdiMagnify },
  }),
  computed: {
    ...mapState('customerLoyalty', ['card', 'accounts', 'fullName', 'loading', 'error', 'searched']),
    phoneNumber: {
      get() {
        return this.$store.state.customerLoyalty.phoneNumber
      },
      set(value) {
        this.$store.commit('customerLoyalty/SET_PHONE', value)
      },
    },
    headers() {
      return [
        { text: 'В карте', value: 'inUse', align: 'center', sortable: false },
        { text: 'Тип', value: 'typeId' },
        { text: 'Счёт', value: 'typeName' },
        { text: 'Баланс', value: 'balance', align: 'end' },
        { text: 'Ступень', value: 'levelName' },
      ]
    },
  },
  created() {
    document.title = 'Бонусы клиента'
  },
  methods: {
    ...mapActions('customerLoyalty', ['fetch']),
    async search() {
      await this.fetch()
    },
    money(value) {
      return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value || 0)
    },
  },
}
</script>

<style lang="scss" scoped>
#customer-loyalty {
  .loyalty-card {
    border: 1px solid rgba(94, 86, 105, 0.14);
    border-radius: 12px;
    padding: 16px;
  }

  .loyalty-divider {
    border-top: 1px solid rgba(94, 86, 105, 0.14);
  }

  .text-sm {
    font-size: 0.8125rem;
  }
}
</style>
